import { Component, OnDestroy, Pipe } from '@angular/core';
import { NavController, ViewController, NavParams, ToastController, AlertController, ModalController, Platform } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { provider } from '../../providers/provider';
import { CartPage } from '../cart/cart';
import { Subject } from 'rxjs';
import { CustomizerProvider } from '../../providers/customizer/customizer';
import moment from 'moment';
import { Variants } from '../productDetail/showVariants/showVariants';

@Component({
  selector: 'page-productDetail',
  templateUrl: 'productDetail.html'
})
export class productDetailPage implements OnDestroy {
  url: any;
  product: any;
  data: any;
  qty = 1;
  max: any;
  cont = 0;
  tot = 0;
  variants = [];
  ingredients = [];
  mandatoryIngredients = [];
  width: any;
  height: any;
  parentItem = null
  private _onDestroy = new Subject();
  choiceVarIngr = [];
  chosenDayForTakeAway = null;
  disponibilita = null;
  imageType = '';
  imageTypeS = '';
  imageTypeM = '';
  imageTypeL = '';

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public translateService: TranslateService,
    public storage: Storage,
    public viewCtrl: ViewController,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public provider: provider,
    public customizer: CustomizerProvider,
    public platform: Platform) {

    this.url = provider.getUrl();

    this.product = navParams.get('product');
    this.data = provider.getMenu();
    platform.ready().then((readySource) => {
      this.height = platform.height();
      this.width = platform.width();

      this.imageTypeS = Math.floor(this.width / 3) + 'px';
      this.imageTypeM = Math.floor(this.width / 2) + 'px';
      this.imageTypeL = this.width + 'px';
    });

    this.imageType = this.data.settings.imageType;
    if (this.product.content.extraProps.imageType && this.product.content.extraProps.imageType !== null)
      this.imageType = this.product.content.extraProps.imageType;

    if (this.provider.getDateForTakeAwayOrDelivery() && this.provider.getDateForTakeAwayOrDelivery() !== undefined) {
      this.chosenDayForTakeAway = this.provider.getDateForTakeAwayOrDelivery();
    } else
      this.chosenDayForTakeAway = null;

    // get product variants
    let productVariants = this.provider.getCartProductVariants(this.product);
    // copy back result
    this.variants = productVariants.variants;
    this.ingredients = productVariants.ingredients;
    this.max = productVariants.max;
    this.parentItem = this.provider.getMenuRow(this.product.parent);

    if (productVariants.mandatoryIngredients.length > 0) {
      this.mandatoryIngredients = productVariants.mandatoryIngredients;
      this.mandatoryIngredients.forEach(element => {

        element.requiredQuantity = (element.requiredQuantity !== null) ? parseInt(element.requiredQuantity) : null;

        if (element.maxRequiredQuantity && element.maxRequiredQuantity !== null) {
          element.maxRequiredQuantity = (element.maxRequiredQuantity !== "") ? parseInt(element.maxRequiredQuantity) : null;
        } else {
          element.maxRequiredQuantity = null;
        }

        if (element.maxVariantsTag && element.maxVariantsTag !== null) {
          element.maxVariantsTag = (element.maxVariantsTag !== "") ? parseInt(element.maxVariantsTag) : null;
        } else {
          element.maxVariantsTag = null;
        }

        if (element.requiredQuantity == 0) {
          element.requiredQuantity = null;
        }

        element.contMaxVar = element.requiredQuantity == null ? 0 : element.requiredQuantity;

        element.cont = 0;
      });
    }

    if (this.product.content.disponibilitaAssoluta && this.product.content.disponibilitaAssoluta !== null) {
      this.disponibilita = this.product.content.disponibilitaAssoluta;
    }
    this.productAvailability();

  }

  productAvailability() {
    let today = moment().format('YYYY-MM-DDTHH:mm:ssZ');
    if (this.chosenDayForTakeAway !== null) {
      let chosenDay = this.chosenDayForTakeAway.slot;
      if (((moment(today).diff(moment(chosenDay), 'days', false)) == 0) && this.product.content.disponibilitaAssoluta !== null)
        this.disponibilita = this.product.content.disponibilitaAssoluta;
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  getImgAllergene(img) {
    return this.url + '/' + img + '?h=40';
  }

  getImage(prod) {
    if (this.data.settings.highResImages) {
      return this.url + prod.img;
    } else {
      switch (this.imageType) {
        case 'S':
          return this.url + prod.img + '?h=' + Math.floor(this.height / 4);
        case 'M':
          return this.url + prod.img + '?h=' + Math.floor(this.height / 3);
        case 'L':
          return this.url + prod.img + '?h=' + Math.floor(this.height / 2);
      }
    }
  }

  ionViewDidEnter() {
    this.tot = this.provider.showTotal();
  }

  cart() {
    this.navCtrl.push(CartPage);
  }

  //allergie
  showAllergy(allergy) {
    let text, contain, allergyText;

    this.translateService.get('CONTIENE').takeUntil(this._onDestroy).subscribe(value => { contain = value });
    this.translateService.get(allergy).takeUntil(this._onDestroy).subscribe(value => { allergyText = value });

    text = '<img src="assets/ALLERGENI/' + allergy + '.png"><br><h2>' + contain + '<br><b>' + allergyText + '</b></h2>';

    let alert = this.alertCtrl.create({
      subTitle: text,
      buttons: ['OK']
    });
    alert.present();
  }

  //visualizzazione immagine variante/ingrediente
  showImage(varingr) {
    let img = this.url + varingr.img;
    let text = '<h2>' + this.provider.renderDescr(varingr) + '</h2><p>' + this.provider.renderDescrEstesa(varingr) + '</p><br><img src="' + img + '">';

    let alert = this.alertCtrl.create({
      subTitle: text,
      buttons: ['OK']
    });
    alert.present();
  }

  // aggiungere o rimuovere quantità del prodotto
  addQty() {
    if (this.disponibilita !== null) {
      if (this.qty < parseInt(this.disponibilita))
        this.qty++;
      else {
        let alert = this.alertCtrl.create({
          title: 'Errore, limite raggiunto!',
          subTitle: 'Ci dispiace ma questo articolo è a disponibilità limitata. Non puoi ordinare più di ' + (this.disponibilita == 1 ? "un prodotto" : this.disponibilita + " prodotti"),
          buttons: ['OK']
        });
        alert.present();
      }
    } else
      this.qty++;
  }

  //Remove item quantity
  removeQty() {
    if (this.qty > 1) {
      this.qty--;
    }
  }

  // aggiungere o togliere quantità alla variante
  increaseQty(item) {
    // controllo della quantità dell'ingrediente
    if ((!item.extraProps.toglibile && !item.extraProps.quantificabile && item.quantita == 1) ||
      (item.extraProps.toglibile && !item.extraProps.quantificabile && item.quantita == 1)) {
      return;
    }

    if (item.quantita < 0) {
      item.quantita++;
      this.cont--;
    } else {
      if (this.cont !== this.max) {
        item.quantita++;
        this.cont++;
      } else {
        this.alertMaxVariant();
      }
    }
  }

  /**
   * Decrease item quantity
   * @param item item in cart
   */
  decreaseQty(item) {
    // controllo della quantità dell'ingrediente
    if ((!item.extraProps.toglibile && !item.extraProps.quantificabile && item.quantita == 0) ||
      (!item.extraProps.toglibile && item.extraProps.quantificabile && item.quantita == 0) ||
      (item.extraProps.toglibile && !item.extraProps.quantificabile && item.quantita == -1)) {
      return;
    }

    if (item.quantita <= 0) {
      if (this.cont !== this.max) {
        item.quantita--;
        this.cont++;
      }
      else {
        this.alertMaxVariant();
      }
    }
    else {
      item.quantita--;
      this.cont--;
    }

  }

  increaseQtyOfMandatoryIngredients(mItem, item) {
    // controllo della quantità dell'ingrediente
    if ((!item.extraProps.toglibile && !item.extraProps.quantificabile && item.quantita == 1) ||
      (item.extraProps.toglibile && !item.extraProps.quantificabile && item.quantita == 1)) {
      return;
    }

    if (mItem.maxRequiredQuantity == null) {

      if (mItem.requiredQuantity == null) {
        mItem.contMaxVar = 0;
      } else if (mItem.contMaxVar <= mItem.requiredQuantity && mItem.contMaxVar !== 0) {
        mItem.contMaxVar--;
      } else {
        this.alertMaxVariant();
        return;
      }

      if (item.quantita < 0) {
        item.quantita++;
        mItem.cont--;
        this.cont--;
        this.pushVarIngr(item);
      } else {
        if (this.cont !== this.max) {
          if (mItem.cont !== mItem.requiredQuantity) {
            item.quantita++;
            mItem.cont++;
            this.cont++;
            this.pushVarIngr(item);
          }
        } else {
          this.alertMaxVariant();
        }
      }

    } else {

      if (item.quantita < 0) {
        item.quantita++;
        mItem.cont--;
        this.pushVarIngr(item);
      } else {
        if (mItem.cont !== mItem.maxRequiredQuantity) {
          item.quantita++;
          mItem.cont++;
          this.pushVarIngr(item);
        } else {
          this.alertMaxVariant();
        }
      }
    }

  }

  decreaseQtyOfMandatoryIngredients(mItem, item) {
    // controllo della quantità dell'ingrediente
    if ((!item.extraProps.toglibile && !item.extraProps.quantificabile && item.quantita == 0) ||
      (!item.extraProps.toglibile && item.extraProps.quantificabile && item.quantita == 0) ||
      (item.extraProps.toglibile && !item.extraProps.quantificabile && item.quantita == -1)) {
      return;
    }

    if (mItem.maxRequiredQuantity == null) {
      if (mItem.requiredQuantity == null) {
        mItem.contMaxVar = 0;
      } else if (mItem.contMaxVar < mItem.requiredQuantity || mItem.contMaxVar == 0) {
        mItem.contMaxVar++;
      } else
        return;

      if (item.quantita <= 0) {
        if (this.cont !== this.max) {
          if (mItem.cont !== mItem.requiredQuantity) {
            item.quantita--;
            mItem.cont++;
            this.cont++;
            this.pushVarIngr(item);
          } else {
            this.alertMaxVariant();
          }
        } else {
          this.alertMaxVariant();
        }
      }
      else {
        item.quantita--;
        mItem.cont--;
        this.cont--;
        this.pushVarIngr(item);
      }
    } else {
      if (item.quantita <= 0) {
        if (mItem.cont !== mItem.requiredQuantity) {
          item.quantita--;
          mItem.cont++;
          this.pushVarIngr(item);
        } else {
          this.alertMaxVariant();
        }
      }
      else {
        item.quantita--;
        mItem.cont--;
        this.pushVarIngr(item);
      }
    }
  }

  pushVarIngr(varIngr) {
    if (this.choiceVarIngr.length !== 0) {
      this.choiceVarIngr.forEach((element, index) => {
        if (varIngr._id == element._id) {
          this.choiceVarIngr.splice(index, 1);
        }
      })
    }

    if (varIngr.quantita !== 0)
      this.choiceVarIngr.push(varIngr);
    else {
      let variants = [];
      this.choiceVarIngr.forEach(element => {
        if (element.ofMandatoryIngredient !== varIngr._id) {
          variants.push(element)
        }
      });
      this.choiceVarIngr = variants;
    }
  }

  createVariantsOfVariantTag(tag, prod) {
    let vars = this.provider.getVariants(this.product);
    let variants = [];

    vars.forEach(variant => {
      if (variant.constraintTags) {
        variant.constraintTags.forEach(tagVar => {
          if (tagVar == tag.variantsTag) {
            variants.push(variant)
          }
        })
      }
    })

    variants.forEach(variant => {
      this.choiceVarIngr.forEach(varChoice => {
        (varChoice.tags).forEach(element => {
          (variant.tags).forEach(element1 => {
            if (element == element1 && varChoice._id == variant._id && varChoice.quantita !== variant.quantita && varChoice.ofMandatoryIngredient == prod) {
              console.log(variant)
              console.log(varChoice)
              variant.quantita = varChoice.quantita;
              console.log(variant)
            }
          });
        });
      })
    })

    this.choiceVarIngr.forEach((item, index, object) => {
      if (item.ofMandatoryIngredient && item.ofMandatoryIngredient == prod)
        object.splice(index, 1);
    })

    return variants;
  }

  showVariants(prod, tag) {

    let variants = this.createVariantsOfVariantTag(tag, prod);

    let selectVariantsModal = this.modalCtrl.create(Variants, { prod: prod, tag: tag, variants: variants });
    selectVariantsModal.onDidDismiss(data => {
      data.forEach(element => {
        this.choiceVarIngr.push(element);
      })
      console.log(this.choiceVarIngr)
    });
    selectVariantsModal.present();
  }

  checkIfHasVariants(ingrId) {
    let data;
    if (this.choiceVarIngr.length !== 0) {
      data = this.choiceVarIngr.filter(element => element.ofMandatoryIngredient == ingrId);
      if (data.length > 0)
        return true;
      else
        return false;
    } else
      return false;
  }

  alertMinVariant() {
    let alert = this.alertCtrl.create({
      title: 'Errore, limite raggiunto!',
      subTitle: 'Non puoi mettere a quantità negativa gli ingredienti di questo articolo !',
      buttons: ['OK']
    });
    alert.present();
  }

  alertMaxVariant() {
    let alert = this.alertCtrl.create({
      title: 'Errore, limite raggiunto!',
      subTitle: 'Non puoi aggiungere altre varianti!',
      buttons: ['OK']
    });
    alert.present();
  }

  /**
   * Check for mandatory ingredients specified in parent group
   * @returns true if there are mandatory ingredients specified and quantity has not been reached
   */
  mandatoryIngredientsCheck(): boolean {
    let result = false;
    this.mandatoryIngredients.forEach(element => {
      if (element.maxRequiredQuantity !== null) {
        if (element.cont < element.contMaxVar) {
          if (element.suggestionDescr && element.suggestionDescr !== null) {
            result = element.suggestionDescr == "" ? element.description : element.suggestionDescr;
          } else {
            result = element.description;
          }
        }
      } else {
        if (element.contMaxVar !== 0) {
          if (element.suggestionDescr && element.suggestionDescr !== null) {
            result = element.suggestionDescr == "" ? element.description : element.suggestionDescr;
          } else {
            result = element.description;
          }
        }
      }
    });
    return result;
  }

  sortMandatoryIngredients() {
    const DirectPrice = 1;
    const PercentagePrice = 2;

    let varIngPerc = [];

    this.choiceVarIngr.map((varIngr, index) => {
      if (varIngr.prezzo.tipo == 2) {
        varIngPerc.push(varIngr);
        this.choiceVarIngr.splice(index, 1);
      }
    });
    return this.choiceVarIngr.concat(varIngPerc);
  }

  // controllo dei giorni necessari per la prenotazione
  manufacturingDaysCheck() {
    if (this.product.content.manufacturingDays && this.product.content.manufacturingDays !== undefined) {
      let today = moment().format();
      //let manufacturingDays = moment(moment(today).add(this.product.content.manufacturingDays, 'days')).format('YYYY-MM-DDTHH:mm:ssZ');
      let chosenDay = this.chosenDayForTakeAway.slot;

      if (moment(today).diff(moment(chosenDay), 'days', false) < 0)
        return true;
      else
        return false;

    } else
      return true;
  }

  //aggiungere al carrello il prodotto
  addToCart(prod) {
    let varianti = [];
    let cart = this.provider.getCart();

    // sort variants by type: percent variants should be at end
    if (this.mandatoryIngredients.length !== 0) {
      varianti = this.sortMandatoryIngredients();
    } else {
      varianti = this.provider.sortCartItemVariants({ variants: this.variants, ingredients: this.ingredients })
    }

    var item = {
      "quantita": this.qty,
      "varIngr": varianti,
      "prodotto": prod,
      "max": this.max,
      "cont": this.cont,
      "disponibilita": this.disponibilita !== null ? parseInt(this.disponibilita) : null,
      "id": Math.random().toString(36).slice(2)
    }

    let sameSpecialProducts = true;
    let qty = item.quantita;
    let jsonifiedCustomProperties = prod.content.trendCustomProperties ? JSON.stringify(prod.content.trendCustomProperties) : null

    // lookup for special items with trendCustomProperties
    cart.map(cartItem => {
      // get cartProduct reference from cart item
      let cartProduct = cartItem.prodotto
      // compute its trendCustomProperties JSON version
      let jsonifiedProductCustomProperties = cartProduct.content.trendCustomProperties ? JSON.stringify(cartProduct.content.trendCustomProperties) : null
      // compute quantity of same item in cart
      if (cartProduct._id == prod._id && cartItem.disponibilita !== null)
        qty += cartItem.quantita
      // lookup for custom properties
      if (jsonifiedCustomProperties && jsonifiedProductCustomProperties) {
        // if they both have custom properties, do a logic AND to check JSON equality
        // so if they are inequal, the variable got false and stay false after
        sameSpecialProducts = sameSpecialProducts && (jsonifiedProductCustomProperties == jsonifiedCustomProperties)
      }
      else if (jsonifiedCustomProperties || jsonifiedProductCustomProperties) {
        // if one of them have custom property but the other not, set variable to false 
        sameSpecialProducts = false
      }
    })

    // check for mandatoryIngredients if present in parent group
    let notEnoughIngredients = this.mandatoryIngredientsCheck();

    // check for disponibilita

    let articoloDisponibile = this.disponibilita !== null ? (qty <= item.disponibilita) : true;

    let manufacturingDays = this.manufacturingDaysCheck();

    if (!sameSpecialProducts) {
      /*let alert = this.alertCtrl.create({
        title: 'Errore!',
        subTitle: 'Non puoi abbinare gli prodotti che hai nel carrello a questo articolo.',
        buttons: ['OK']
      })
      alert.present();*/
      let toast = this.toastCtrl.create({
        message: 'Non puoi abbinare gli prodotti che hai nel carrello a questo articolo.',
        duration: 5000,
        position: 'middle'
      });
      toast.present();
    }
    else if (!articoloDisponibile) {
      if (this.disponibilita > 0) {
        let toast = this.toastCtrl.create({
          message: 'Prodotto a disponibilità limitata. Non puoi ordinare complessivamente più di ' + (this.disponibilita == 1 ? "un prodotto" : this.disponibilita + " prodotti"),
          duration: 5000,
          position: 'middle'
        });
        toast.present();
      } else {
        let toast = this.toastCtrl.create({
          message: 'Ci dispiace ma questo articolo è terminato.',
          duration: 5000,
          position: 'middle'
        });
        toast.present();
      }
    }
    else if (!manufacturingDays) {
      let toast = this.toastCtrl.create({
        message: 'Prodotto da prenotare! Questo articolo richiede ' + (this.product.content.manufacturingDays == 1 ? 'un giorno' : this.product.content.manufacturingDays + " giorni") + ' di preparazione.',
        duration: 5000,
        position: 'middle'
      });
      toast.present();
    }
    else if (notEnoughIngredients) {
      let toast = this.toastCtrl.create({
        message: 'Per poter ordinare questo prodotto devi inserire tutti i componenti obbligatori di: ' + (notEnoughIngredients.toString()).toUpperCase(),
        duration: 5000,
        position: 'middle'
      });
      toast.present();
    }
    else {
      // everything is ok, add product to cart
      this.provider.addToCart(item);
      // show user toast
      let toast = this.toastCtrl.create({
        message: 'Prodotto aggiunto al carrello!',
        duration: 2000,
        position: 'bottom'
      });
      toast.present();
      // return to product list
      this.navCtrl.pop();
    }


    //return;

  }

  readMore(descr) {
    let text;

    text = this.provider.renderDescrEstesa(descr);

    let alert = this.alertCtrl.create({
      title: 'Informazioni',
      message: text,
      buttons: ['OK']
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/productDetail/productDetail.ts